export default __webpack_public_path__ + "static/media/LogoLight.phd.1758520a.svg";